module.exports = __webpack_public_path__ + "static/media/Encabezado.0711c8d6.jpg";